import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemBase } from '@fi-app/components/items-list/list-row/list-row-item/list-row-item-base';

@Component({
    selector: 'fi-site-design-access-item-cell',
    template: ` <fi-site-design-access-item [siteDesignIds]="data[head.PropertyName]"></fi-site-design-access-item> `,
    styleUrls: ['./fi-site-design-access-item-cell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-site-design-access-item-cell' },
    standalone: false,
})
export class FiSiteDesignAccessItemCellComponent extends ItemsListRowItemBase {}
